import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getAccountOwnersList, getLeadByID } from '../../redux/reduxActions/leadActions';
import LeadItem from './LeadItem';
import FolderAndEstimationPopup from './FolderAndEstimationPopup';

const ShowSelectedLead = (props) => {
  useEffect(() => {
  	props.getLeadByID(props.match.params.id);
	props.getAccountOwnersList();
  }, []);
  const needUpdateData = () => {
    // console.log('needUpdateData showselectedled');
    props.getLeadByID(props.match.params.id);
  };

  const { selectedLead } = props;
  return (
    <div>
      <LeadItem selected data={selectedLead} {...props} />
      <FolderAndEstimationPopup needUpdateData={needUpdateData} {...props} />
    </div>
  );
};
export default connect((state) => ({
  selectedLead: state.leadReducer.selectedLead,
}), { getLeadByID, getAccountOwnersList })(ShowSelectedLead);
